(() => {
  const selector = 'form[action*="/contact"]';
  const activeForms = new Map();

  const insertStatus = (form, message, type) => {
    let status = form.querySelector('[data-bst-contact-feedback]');
    if (!status) {
      status = document.createElement('div');
      status.dataset.bstContactFeedback = '';
      status.setAttribute('role', 'status');
      status.setAttribute('aria-live', 'polite');
      form.append(status);
    }
    status.className = `bst-contact-feedback bst-contact-feedback--${type}`;
    status.textContent = message;
    status.scrollIntoView({ block: 'nearest', behavior: 'auto' });
    return status;
  };

  const initialiseForm = (form) => {
    if (form.querySelector('input[name="form_type"]')?.value !== 'contact') return;
    if (form.dataset.bstContactFeedbackReady === 'true') return;
    form.dataset.bstContactFeedbackReady = 'true';

    // Receipt is rendered by Liquid form.posted_successfully?, never inferred
    // from a visitor-editable query string or a cancelled submit event.
    let recoveryTimer;
    const reset = () => {
      window.clearTimeout(recoveryTimer);
      form.removeAttribute('aria-busy');
      form.querySelectorAll('[data-bst-contact-disabled]').forEach((control) => {
        control.removeAttribute('aria-disabled');
        control.disabled = false;
        delete control.dataset.bstContactDisabled;
      });
    };
    activeForms.set(form, reset);
    form.addEventListener('submit', (event) => {
      if (!form.checkValidity()) return;
      if (form.getAttribute('aria-busy') === 'true') {
        event.preventDefault();
        return;
      }
      form.setAttribute('aria-busy', 'true');
      insertStatus(form, 'Submitting your information…', 'submitting');
      form.querySelectorAll('button[type="submit"], input[type="submit"]').forEach((control) => {
        if (control.disabled) return;
        control.dataset.bstContactDisabled = 'true';
        control.setAttribute('aria-disabled', 'true');
        control.disabled = true;
      });
      // Captcha or another form handler may intercept the native submission.
      // Do not leave an unusable disabled form or falsely announce delivery.
      recoveryTimer = window.setTimeout(() => {
        if (!form.isConnected) return;
        reset();
        insertStatus(form, 'We have not received a submission confirmation on this page. Complete any security check shown, or retry. If this continues, use our contact email or WhatsApp.', 'warning');
      }, 25000);
    });
  };

  const initialise = (root = document) => root.querySelectorAll(selector).forEach(initialiseForm);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialise());
  else initialise();
  document.addEventListener('shopify:section:load', (event) => initialise(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    activeForms.forEach((reset, form) => {
      if (event.target.contains(form)) {
        reset();
        activeForms.delete(form);
      }
    });
  });
  window.addEventListener('pageshow', () => {
    activeForms.forEach((reset, form) => {
      reset();
      form.querySelector('.bst-contact-feedback--submitting')?.remove();
      if (!form.isConnected) activeForms.delete(form);
    });
  });
  window.addEventListener('pagehide', () => activeForms.forEach((reset) => reset()));
})();
